import { IApplicationState } from '../../types/redux';

export function getDeveloperRegions(state: IApplicationState) {
  return state.developer.regions;
}
